import React, {memo} from 'react';
import {View, Text} from 'react-native';

import { StyleSheet } from 'react-native';
import {RNEText, SVGIcon} from '../../components';

const ConsultationDetailPlaceholder = () => {

  return (
    <View style={styles.root}>
      <SVGIcon name="selection" size={96} />

      <View>
        <RNEText
          label="Select a conversation from the list"
          variant="subheader"
          weight="600"
          color="blackLight"
          style={subtitleFontSize20}
        />
      </View>
    </View>
  );
};

const subtitleFontSize20 = {
  fontSize: 20,
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default memo(ConsultationDetailPlaceholder);
